import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { RootState } from 'features/app/store/store';
import { VpnStatus } from 'features/vpn-behavior/enums';

export interface VpnBehaviorState {
  vpnStatus: VpnStatus;
  bypassVpnRestrictions: boolean;
}

export const initialVpnBehaviorState: VpnBehaviorState = {
  vpnStatus: VpnStatus.Unknown,
  bypassVpnRestrictions: false,
};

export const vpnBehaviorSlice = createSlice({
  name: 'vpn-behavior',
  initialState: initialVpnBehaviorState,
  reducers: {
    vpnChecked: (state, action: PayloadAction<VpnStatus>) => {
      state.vpnStatus = action.payload;
    },
    vpnRestrictionBypass: (state, action: PayloadAction<boolean>) => {
      state.bypassVpnRestrictions = action.payload;
    },
  },
});

export const { vpnChecked, vpnRestrictionBypass } = vpnBehaviorSlice.actions;

export const vpnBehaviorReducer = vpnBehaviorSlice.reducer;

export const selectIsVpnDetected = ({ vpnBehavior }: RootState) =>
  vpnBehavior.vpnStatus === VpnStatus.Detected;

export const selectVpnStatus = ({ vpnBehavior }: RootState) =>
  vpnBehavior.vpnStatus;

export const selectIsVpnRestrictionBypassed = ({ vpnBehavior }: RootState) =>
  vpnBehavior.bypassVpnRestrictions;
